export const KBO_UPDATE_ALWAYS_VISIBLE = false;

export const KBO_UPDATE_RELEASE_ID = "aut-10586";

export const KBO_UPDATE_HELP_ARTICLE_URL =
    "https://www.authenticxhelp.com/en/articles/17061160-kbo-updates";

function kboUpdateStorageKey(userId: string) {
    return `kbo-update-seen:${KBO_UPDATE_RELEASE_ID}:${userId}`;
}

export function hasSeenKboUpdate(userId: string): boolean {
    if (KBO_UPDATE_ALWAYS_VISIBLE) return false;

    try {
        return localStorage.getItem(kboUpdateStorageKey(userId)) === "true";
    } catch {
        return false;
    }
}

export function storeKboUpdateSeen(userId: string) {
    try {
        localStorage.setItem(kboUpdateStorageKey(userId), "true");
    } catch {
        return;
    }
}
